import * as React from "react";

const SvgDownload = ({ color, size }) => (
  <svg
    viewBox="0 0 18 19"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity={0.3}
      d="M9.75 7.25v-3h-1.5v4.5h-.877l1.628 1.627 1.627-1.627h-.877v-1.5z"
      fill={color}
    />
    <path
      d="M11.25 7.25v-4.5h-4.5v4.5h-3L9 12.5l5.25-5.25h-3zM9 10.377 7.372 8.75h.878v-4.5h1.5v4.5h.877L9 10.377zM3.75 14h10.5v1.5H3.75V14z"
      fill={color}
    />
  </svg>
);

export default SvgDownload;
